import { Injectable } from '@angular/core';
import { Topics } from '@common/interfaces/topics';
import ColorHash from 'color-hash';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { AnagraficaServiziQuery } from './anagraficaServizi.query';
import { AnagraficaServiziStore } from './anagraficaServizi.store';
import { IAnagraficaServizioAggiuntivo } from '@common/interfaces/anagraficaServizioAggiuntivo';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaServiziService extends CrudService<IAnagraficaServizioAggiuntivo, AnagraficaServiziStore, AnagraficaServiziQuery> {
  colorHash = new ColorHash();

  constructor(
    protected store: AnagraficaServiziStore,
    public query: AnagraficaServiziQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(Topics.ANAGRAFICA_SERVIZIO_AGGIUNTIVO, store, query, actionService, updateStrategy);
  }
}
